import {appLink} from "@rw/cars_routes";

const PL_TO_ASCII: Record<string, string> = {
    ą: "a",
    ć: "c",
    ę: "e",
    ł: "l",
    ń: "n",
    ó: "o",
    ś: "s",
    ź: "z",
    ż: "z"
};

/** ASCII slug from seller display name (e.g. "Auto Top" → "auto-top"). */
export const getSellerSlug = (name: string): string =>
    name
        .trim()
        .toLowerCase()
        .split("")
        .map((ch) => PL_TO_ASCII[ch] || ch)
        .join("")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

/**
 * Prefer WP `seller_slug` when present (may differ from slugified display name).
 * Example: name "RADEX AUTO KOMIS" → radex-auto-komis, but seller_slug is auto-komis-radex.
 */
export const getSellerUrl = (name: string, sellerSlug?: string | null): string | null => {
    const slug = (sellerSlug || "").trim() || getSellerSlug(name);
    if (!slug) {
        return null;
    }
    return appLink.seller.detail({slug});
};
